import { Coins, LCDClient } from '@terra-money/terra.js';

export const chainID = 'columbus-5';

/**
 * Fallback gas prices, used both to build the client and to size a fee when
 * the live gas-price endpoint is unreachable (it currently is -- the Terra
 * Classic FCD it points at is decommissioned).
 */
export const gasPricesJson = {
    uluna: '28.325', usdr: '0.52469', uusd: '0.75', ukrw: '850.0', umnt: '2142.855',
    ueur: '0.625', ucny: '4.9', ujpy: '81.85', ugbp: '0.55', uinr: '54.4',
    ucad: '0.95', uchf: '0.7', uaud: '0.95', usgd: '1.0', uthb: '23.1',
    usek: '6.25', unok: '6.25', udkk: '4.5', uidr: '10900.0', uphp: '38.0',
    uhkd: '5.85', umyr: '3.0', utwd: '20.0',
};

/**
 * One Terra Classic client for the whole app.
 *
 * The URL used to be written out separately in every page, which is why
 * switching endpoints took a commit per file. Keep it here so the next switch
 * is one edit, and so the price ticker and the pages cannot drift onto
 * different nodes and disagree.
 */
export const lcdClient = new LCDClient({
    URL: 'https://terra-classic-lcd.publicnode.com',
    chainID,
    gasPrices: new Coins(gasPricesJson),
    gasAdjustment: '1.5',
    isClassic: true,
});
